import Service from "../../Service";
import Axios from "../../Config/API";

export async function ExportarExcelUnidadesLiberacaoVistoriaService(
    idEmpreendimento: number
) {
    return Service(
        Axios.get<Blob>(
            `/vistoria/casovistoria/exportarexcelunidadesliberacaovistoria?idEmpreendimento=${idEmpreendimento}`,
            {
                responseType: "blob",
            }
        )
    );
}

export async function LiberarUnidadesEmMassaVistoriaService(
    requestBody: FormData
) {
    return Service(
        Axios.post(
            `/vistoria/casovistoria/liberarunidadesvistoriaemmassa`,
            requestBody
        )
    );
}